'use strict';

import startVideo from '../archives/video/transitions.mp4';

var SceneVideo = new Phaser.Class({

  Extends: Phaser.Scene,

  initialize:

  function SceneEnter ()
  {
    Phaser.Scene.call(this, { key: 'sceneVideo', active: false });
  },

  init: function(params){
    this.params = params;

    this.sceneBoot = this.scene.get('sceneBoot');
    this.scaler = this.sceneBoot.scaler;

    this.sceneBoot.currentScene = 'sceneVideo';

    this.sceneBoot.scaleMode = 'full';
    this.scaler.scaleMode = 'full';

    this.scene.bringToTop();

    this.sceneBoot.windowResized = true;

    this.enterNextPage = false;

    this.videoPlayed = false;
  },

  preload: function ()
  {

  },

  create: function ()
  {
    var self = this;
    var sprite, designX, designY;

    this.cameras.main.visible = false;

    var designX = 0;
    var designY = 0;
    sprite = this.add.rectangle(
      this.scaler.scaleX(this.scaler.designRefWidth()/2 + designX),
      this.scaler.scaleY(this.scaler.designRefHeight()/2 + designY),
      1920, 
      1080, 
      0xffffff, 
      1);
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.setInteractive();
    sprite.keepData = { 
      resized: true,
      xlocation: 'center',
      ylocation: 'center',
      designX: designX,
      designY: designY,
      fill: true,
    };

    designX = this.scaler.designRefWidth()/2;
    designY = this.scaler.designRefHeight()/2;
    sprite = this.add.video(
      this.scaler.scaleX(designX),
      this.scaler.scaleY(designY)
      // 'transitions'
    );
    sprite.setOrigin(0.5, 0.5);
    sprite.loadURL(startVideo);

    this.video = sprite;
    sprite.keepData = {
      resized: true,
      designX: designX,
      designY: designY
    };
    this.scaler.scaleSpriteByMax(sprite);
    this.video.setVolume(0);
    // sprite.play();

    this.video.video.addEventListener('x5videoenterfullscreen', function() {
      console.log('fullscreen...');
      document.getElementById('video-container').style.display = 'none';
    }, false);

    this.video.video.addEventListener('x5videoexitfullscreen', function() {
      console.log('exit fullscreen...');
      console.log('next page (exit fullscreen)');
      self.nextPage();
    }, false);

    document.getElementById('btn-close').onclick = function(){
      self.nextPage();
    };

    sprite.on('created', function(video, width, height){
      console.log('#video created...' + this.video.getDuration());
      
      this.scaler.scaleSpriteByMax(this.video);

      var color = utils.getVideoColor(video);
      console.log(color);
      if(color.r == 0 && color.g == 0 && color.b == 0){
        //无法在phaser内正常播放，1.全屏播放；2.视频内容不显示

        window.videoCannotPlay = true;
        utils.setCookie('videoCannotPlay', window.videoCannotPlay);

        this.showVideoMask();
      } else{
        window.videoCannotPlay = false;
        utils.setCookie('videoCannotPlay', window.videoCannotPlay);
      }

    }, this);

    sprite.on('play', function(video){
      console.log('#video play');
    }, this);

    sprite.on('complete', function(video, width, height){
      // this.nextPage();
    }, this);

    this.video.on('error', function(video, error){
      console.log('VIDEO ERROR');
      console.log(error);
    }, this);

    designX = 0;
    designY = -72;
    sprite = this.add.image(
      this.scaler.scaleX(this.scaler.designRefWidth()/2 + designX),
      this.scaler.scaleY(this.scaler.designRefHeight() + designY),
      'btn_skip'
    );
    sprite.setOrigin(0.5, 1);
    this.scaler.scaleSpriteByHeight(sprite);
    sprite.keepData = {
      resized: true,
      xlocation:'center',
      ylocation:'bottom',
      designX: designX,
      designY: designY,
      enableClick: true,
    };

    sprite.setInteractive();
    sprite.on("pointerdown", pointer => {
      this.btnSkipSprite.alpha = 0.6;

      this.btnSkipSprite.isPressed = true;
    });
    sprite.on("pointerup", pointer => {
      this.btnSkipSprite.alpha = 1.0;
      if(this.btnSkipSprite.isPressed) {
        this.skip();
      }
      this.btnSkipSprite.isPressed = false;
    });
    this.btnSkipSprite = sprite;

    this.input.on('pointerup', function () {
      utils.updateButtonsAlpha(this);
    }, this);
  },

  update: function(){
    var self = this;
    if(this.scene.get('sceneEnter').clickedEnterBtn && this.video && this.video.getCurrentTime() >= 0.5) {
      this.scene.get('sceneEnter').clickedEnterBtn = false;
      this.scene.get('sceneEnter').circleAnimationTimer.destroy();
      this.scene.get('sceneEnter').outAnimation();

      this.cameras.main.visible = true;
      this.cameras.main.alpha = 0;
      this.enterAnimation(function() {
      });
    }
    if(this.videoPlayed && this.video && this.video.getCurrentTime() >= 18.4) {
      this.nextPage();
    }
  },

  resized: function () {
    var phaserElements = this.children.list;
    for(var i = 0; i < phaserElements.length; i ++){
      var s = phaserElements[i];
      if(s.keepData && s.keepData.resized == true){
        if(s.type == 'Video'){
          s.x = this.scaler.scaleX(this.scaler.designRefWidth()/2);
          s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2);
          this.scaler.scaleSpriteByMax(s);
        } else{
          if(s.keepData.xlocation && s.keepData.xlocation == 'right'){
            s.x = this.scaler.scaleX(this.scaler.designRefWidth() + s.keepData.designX);
          } else if(s.keepData.xlocation && s.keepData.xlocation == 'center'){
            s.x = this.scaler.scaleX(this.scaler.designRefWidth()/2 + s.keepData.designX);
          } else {
            s.x = this.scaler.scaleX(s.keepData.designX);
          }

          if(s.keepData.ylocation && s.keepData.ylocation == 'bottom'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight() + s.keepData.designY);
          } else if(s.keepData.ylocation && s.keepData.ylocation == 'center'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2 + s.keepData.designY);
          } else{
            s.y = this.scaler.scaleY(s.keepData.designY);
          }
          
          if(s.keepData.fill){
            this.scaler.scaleSpriteFill(s);
          } else if(s.keepData.scaleByMax){
            this.scaler.scaleSpriteByMax(s);
          }else{
            this.scaler.scaleSprite(s);
          }


          if(s.keepData.scale){
            s.scale *= s.keepData.scale;
          }
        }
      }
    }
  },

  videoPlay: function() {
    this.video.setVolume(100);
    this.video.setCurrentTime(0);
    this.video.play();
    this.videoPlayed = true;
  },

  showVideoMask: function(){
    console.log('open video container');
    document.getElementById('video-container').appendChild(this.video.video);
    document.getElementById('video-container').style.display = 'block';
    this.video.video.style.width = '100%';
    this.video.video.style.height = '100%';
    this.video.video.style.margin = 'auto';
    this.video.video.style.position = 'absolute';
    this.video.video.style.top = '0px';
    this.video.video.style.bottom = '0px';
  },

  nextPage: function(){
    if(this.enterNextPage) {
      return;
    }

    this.enterNextPage = true;

    var self = this;
    // this.video.setPaused(true);
    this.scene.get('sceneEnter').scene.stop();

    document.getElementById('video-container').style.display = 'none';

    if(window.videoCannotPlay) {
      this.scene.get('sceneTitle').scene.setVisible(true);
      this.scene.get('sceneTitle').cameras.main.alpha = 1;
      this.scene.get('sceneTitle').enterAnimation();
      this.scene.start('scenePreface');
    } else {
      this.outAnimation();

      this.scene.get('sceneTitle').scene.setVisible(true);
      this.scene.get('sceneTitle').cameras.main.alpha = 1;
      this.scene.get('sceneTitle').enterAnimation();
      this.scene.launch('scenePreface');
    }
  },

  skip: function() {
    if(this.enterNextPage) {
      return;
    }

    this.enterNextPage = true;

    this.scene.get('sceneEnter').scene.stop();

    document.getElementById('video-container').style.display = 'none';

    this.scene.get('sceneTitle').scene.setVisible(true);
    this.scene.get('sceneTitle').cameras.main.alpha = 1;
    this.scene.get('sceneTitle').enterAnimation();
    this.scene.start('scenePreface');
  },

  enterAnimation: function(func) {
    var self = this;
    var duration = GC.animationDuration;
    this.tweens.add({
      targets: this.cameras.main,
      alpha: {
        start: 0,
        to: 1
      },
      duration: duration,
      delay: 0,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        if(func) {
          func();
        }
      },
    }); 
  },

  outAnimation: function() {
    var self = this;
    var duration = GC.animationDuration;
    
    var phaserElements = this.children.list;
    phaserElements.forEach(sprite => {
      if(sprite.keepData.resized) {
        sprite.keepData.resized = false;
      }
    });

    this.tweens.add({
      targets: this.cameras.main,
      alpha: {
        start: 1,
        to: 0
      },
      duration: duration,
      delay: 0,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        self.scene.stop();
      },
    }); 
  },
});
export default SceneVideo;